import { render, staticRenderFns } from "./CsDashboards.vue?vue&type=template&id=61983470&scoped=true&"
import script from "./CsDashboards.vue?vue&type=script&lang=js&"
export * from "./CsDashboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61983470",
  null
  
)

export default component.exports